
















import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
interface IQues {
  id: number
  question: string
  answer: string
}
@Component({
  components: {
    HeaderBar,
  },
})
export default class QuesDetail extends Vue {
  quesInfo!: IQues
  created() {
    const info = localStorage.getItem('QC_ques') || '{}'
    this.quesInfo = JSON.parse(info)
    console.log(this.quesInfo)
  }
  transBr(val: string) {
    return val.replace(/\\n/g, '<br/>')
  }
  exitWebview() {
    ;(window as any).MgtvApi.closeWebView()
  }
}
